export default __webpack_public_path__ + "62ddbd3d95bbf7d6967ec628462ff3b0.mp3";